package one.healthium.reminders.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
internal data class RemindersDto(
    @SerialName("reminders") val reminders: List<ReminderDto>,
)
